var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.36,
    cy: 86.15,
    r: 47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.64,
    y1: 132.14,
    x2: 99.82,
    y2: 118.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.14,
    y: 124.44,
    width: 14.03,
    height: 57.85,
    transform: "translate(131.32 2.17) rotate(46.65)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MAGNIFYING_GLASS.7893313b7fc2200db7680f662fbeba22.svg";
export { ForwardRef as ReactComponent };